module.exports = __webpack_public_path__ + "img/square.4e84e7f0.svg";